import Base from './Base'

export default class Pizza extends Base {
    type = 'pizza';
    pay_for = 'average';
    max_flavors = 1;
  
    toJSON = () => {
        let me = this, _this = {};
        ['_id', 'ref_id', 'parent', 'position', 'type', 'pay_for', 'name', 'items', 'edges', 'extra_ingredients', 'max_flavors', 'new', 'delete', 'show', 'highlight'].map((prop) => { _this[prop] = me[prop]; });
        return _this;
    }
}